import { PMService } from "../service/pm.service"

export const PMServiceConstant = {
    API : 'PM'
}

export const PMAPIServiceConstant = {
    GETPMSearch: `${PMServiceConstant.API}/GetPMSearch`,
    CREATEPMBUILD: `${PMServiceConstant.API}/CreatePMBuild`,
    ADDNEWPM: `${PMServiceConstant.API}/CreatePMBuild_MCT`,
    // GETPMBUILD: `${PMServiceConstant.API}/GetPMBuild`,
    GETPMBUILD: `${PMServiceConstant.API}/GetPMBuild_save`,
    COPYPMBUILD: `${PMServiceConstant.API}/CopyPMBuild`,
    UPDATEPMBUILD: `${PMServiceConstant.API}/UpdatePMBuild`,
    GETROUTETAG: `${PMServiceConstant.API}/GetRouteTag`,
    GETFREQINDICATOR: `${PMServiceConstant.API}/GetFrequencyIndicatorSearch`,
    DELETEPMBUILD: `${PMServiceConstant.API}/DeletePmBuild`,
    GETMINORSERVICETYPE: `${PMServiceConstant.API}/GetMinorServiceType`,
    GETSERVICETYPE: `${PMServiceConstant.API}/GetServiceType`,
    GETMWODATA: `${PMServiceConstant.API}/GetMWODetails`,
    // GETVALIDMWO: `${PMServiceConstant.API}/GetMWODetailInfo`,
    GETVALIDMWO: `${PMServiceConstant.API}/GetMWODetailInfo_mctmwo`,
    // ADDASSOCIATIONS: `${PMServiceConstant.API}/AddAssociations`,
    ADDASSOCIATIONS: `${PMServiceConstant.API}/AddAssociations_mctmwo`,
    // SAVEPMBUILD: `${PMServiceConstant.API}/SavePMBuild`,
    SAVEPMBUILD: `${PMServiceConstant.API}/SavePMBuildMCT`,
    // VALIDATEPMBUILD: `${PMServiceConstant.API}/ValidatePMBuildOnSave`,
    VALIDATEPMBUILD: `${PMServiceConstant.API}/ValidatePMBuild_OnSave`,
    DELETEEQUIPMENTROUTEASSOCIATION: `${PMServiceConstant.API}/DeleteEquipmentRouteAssociation`,
    VALIDATEMWONUMBERONSAVE: `${PMServiceConstant.API}/ValidateMwoNumberOnSave`,
    // IMPORTPMHEADER: `${PMServiceConstant.API}/ImportPMHeader`,
    IMPORTPMHEADER: `${PMServiceConstant.API}/ImportPMHeaderMCT`,
    IMPORTPMROUTE: `${PMServiceConstant.API}/ImportPMRouteMCT`,
    // IMPORTPMROUTE: `${PMServiceConstant.API}/ImportPMRoute`,
}